import React, { useState } from 'react';
import { API_ENDPOINTS, fetchWithCredentials } from '../config/api';
import { useAuth } from '../contexts/AuthContext';

function DebugPage() {
  const { isLoggedIn, user } = useAuth();
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const addResult = (test, result, error = null) => {
    setTestResults(prev => [...prev, {
      test,
      result,
      error,
      timestamp: new Date().toLocaleTimeString()
    }]);
  };

  const testAuth = async () => {
    try {
      const response = await fetchWithCredentials(API_ENDPOINTS.AUTH.ME, { method: 'GET' });
      addResult('认证测试', '成功', null);
      console.log('认证响应:', response);
    } catch (error) {
      addResult('认证测试', '失败', error.message);
    }
  };

  const testOrders = async () => {
    try {
      const response = await fetchWithCredentials(API_ENDPOINTS.ORDERS.MY, { method: 'GET' });
      addResult('订单列表测试', '成功', null);
      console.log('订单响应:', response);
    } catch (error) {
      addResult('订单列表测试', '失败', error.message);
    }
  };

  const testSimulatePayment = async () => {
    try {
      // 先获取订单列表
      const orders = await fetchWithCredentials(API_ENDPOINTS.ORDERS.MY, { method: 'GET' });
      const pendingOrder = orders.find(order => order.paymentStatus === 'pending');
      
      if (!pendingOrder) {
        addResult('模拟支付测试', '失败', '没有找到待支付的订单');
        return;
      }

      const response = await fetchWithCredentials(
        `${API_ENDPOINTS.ORDERS.BASE}/${pendingOrder.id}/simulate-payment`,
        { method: 'POST' }
      );
      
      addResult('模拟支付测试', '成功', null);
      console.log('模拟支付响应:', response);
    } catch (error) {
      addResult('模拟支付测试', '失败', error.message);
    }
  };

  const runAllTests = async () => {
    setLoading(true);
    setTestResults([]);
    
    await testAuth();
    await testOrders();
    await testSimulatePayment();
    
    setLoading(false);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>API调试页面</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>当前状态</h3>
        <p>登录状态: {isLoggedIn ? '已登录' : '未登录'}</p>
        <p>用户信息: {user ? JSON.stringify(user) : '无'}</p>
        <p>API基础URL: {API_ENDPOINTS.ORDERS.BASE.replace('/simulate-payment', '')}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>测试操作</h3>
        <button onClick={runAllTests} disabled={loading} style={{ marginRight: '10px' }}>
          {loading ? '测试中...' : '运行所有测试'}
        </button>
        <button onClick={testAuth} disabled={loading} style={{ marginRight: '10px' }}>
          测试认证
        </button>
        <button onClick={testOrders} disabled={loading} style={{ marginRight: '10px' }}>
          测试订单
        </button>
        <button onClick={testSimulatePayment} disabled={loading}>
          测试模拟支付
        </button>
      </div>

      <div>
        <h3>测试结果</h3>
        {testResults.length === 0 ? (
          <p>暂无测试结果</p>
        ) : (
          <div>
            {testResults.map((result, index) => (
              <div key={index} style={{ 
                padding: '10px', 
                margin: '5px 0', 
                border: '1px solid #ddd',
                borderRadius: '5px',
                backgroundColor: result.error ? '#ffebee' : '#e8f5e9'
              }}>
                <strong>{result.test}</strong> - {result.result}
                {result.error && <div style={{ color: 'red', marginTop: '5px' }}>错误: {result.error}</div>}
                <div style={{ fontSize: '12px', color: '#666' }}>{result.timestamp}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default DebugPage; 